import React, { useState, useEffect } from 'react';

const GalleryList = () => {
  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [viewMode, setViewMode] = useState('grid'); // 'grid' or 'list'

  useEffect(() => {
    // Mock data for gallery photos
    // In a real application, this would come from an API call
    const mockPhotos = [
      {
        id: 1,
        title: 'Annual Sports Day 2023',
        category: 'Events',
        imageUrl: '/api/placeholder/300/200',
        uploadedDate: '2023-11-15',
        uploadedBy: 'Admin',
        description: 'Annual sports day celebration with various events and competitions.'
      },
      {
        id: 2,
        title: 'Science Fair Exhibition',
        category: 'Events',
        imageUrl: '/api/placeholder/300/200',
        uploadedDate: '2023-11-10',
        uploadedBy: 'Admin',
        description: 'Annual science fair with innovative projects from students.'
      },
      {
        id: 3,
        title: 'Mathematics Classroom',
        category: 'Campus',
        imageUrl: '/api/placeholder/300/200',
        uploadedDate: '2023-11-05',
        uploadedBy: 'Admin',
        description: 'Modern mathematics classroom with interactive learning tools.'
      },
      {
        id: 4,
        title: 'Basketball Tournament',
        category: 'Sports',
        imageUrl: '/api/placeholder/300/200',
        uploadedDate: '2023-11-01',
        uploadedBy: 'Admin',
        description: 'Inter-class basketball tournament finals.'
      },
      {
        id: 5,
        title: 'Art and Craft Exhibition',
        category: 'Events',
        imageUrl: '/api/placeholder/300/200',
        uploadedDate: '2023-10-28',
        uploadedBy: 'Admin',
        description: 'Students showcase their creative art and craft works.'
      },
      {
        id: 6,
        title: 'Library Reading Corner',
        category: 'Campus',
        imageUrl: '/api/placeholder/300/200',
        uploadedDate: '2023-10-25',
        uploadedBy: 'Admin',
        description: 'Quiet reading corner in the school library.'
      }
    ];

    setTimeout(() => {
      setPhotos(mockPhotos);
      setLoading(false);
    }, 1000); // Simulate API call delay
  }, []);

  const filteredPhotos = photos.filter(photo => {
    return !selectedCategory || photo.category === selectedCategory;
  });

  const uniqueCategories = [...new Set(photos.map(photo => photo.category))];

  const handleDelete = (photoId) => {
    if (window.confirm('Are you sure you want to delete this photo?')) {
      setPhotos(photos.filter(photo => photo.id !== photoId));
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center py-8">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen py-8">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-3xl font-bold text-gray-800">Gallery Management</h1>
          <button className="bg-primary text-white px-4 py-2 rounded hover:bg-blue-700 transition flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" />
            </svg>
            Upload Photos
          </button>
        </div>

        <div className="bg-white rounded-lg shadow-md p-6 mb-6">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">
            <div>
              <label className="block text-gray-700 mb-2">Filter by Category</label>
              <select
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.target.value)}
                className="border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary"
              >
                <option value="">All Categories</option>
                {uniqueCategories.map(category => (
                  <option key={category} value={category}>{category}</option>
                ))}
              </select>
            </div>
            
            <div className="flex space-x-2">
              <button
                onClick={() => setViewMode('grid')}
                className={`p-2 rounded ${viewMode === 'grid' ? 'bg-primary text-white' : 'bg-gray-200 text-gray-700'} hover:bg-primary hover:text-white`}
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM11 13a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
                </svg>
              </button>
              <button
                onClick={() => setViewMode('list')}
                className={`p-2 rounded ${viewMode === 'list' ? 'bg-primary text-white' : 'bg-gray-200 text-gray-700'} hover:bg-primary hover:text-white`}
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd" />
                </svg>
              </button>
            </div>
          </div>
        </div>

        {viewMode === 'grid' ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {filteredPhotos.map((photo) => (
              <div key={photo.id} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition">
                <div className="aspect-w-16 aspect-h-9">
                  <img 
                    src={photo.imageUrl} 
                    alt={photo.title}
                    className="w-full h-48 object-cover"
                  />
                </div>
                <div className="p-4">
                  <h3 className="font-semibold text-gray-800 mb-1 truncate">{photo.title}</h3>
                  <p className="text-sm text-gray-600 mb-2">{photo.category}</p>
                  <p className="text-xs text-gray-500 mb-3 line-clamp-2">{photo.description}</p>
                  <div className="flex justify-between items-center text-xs text-gray-500">
                    <span>{photo.uploadedDate}</span>
                    <span>by {photo.uploadedBy}</span>
                  </div>
                  <div className="flex space-x-2 mt-3">
                    <button className="flex-1 text-primary hover:text-blue-700 text-sm py-1">
                      Edit
                    </button>
                    <button 
                      onClick={() => handleDelete(photo.id)}
                      className="flex-1 text-red-600 hover:text-red-800 text-sm py-1"
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="bg-white rounded-lg shadow-md overflow-hidden">
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Thumbnail</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Title</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Category</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Description</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Uploaded By</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {filteredPhotos.map((photo) => (
                    <tr key={photo.id} className="hover:bg-gray-50">
                      <td className="px-6 py-4 whitespace-nowrap">
                        <img 
                          src={photo.imageUrl} 
                          alt={photo.title}
                          className="w-16 h-16 object-cover rounded"
                        />
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{photo.title}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        <span className="px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full">
                          {photo.category}
                        </span>
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-500 max-w-xs truncate">{photo.description}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{photo.uploadedBy}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{photo.uploadedDate}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                        <button className="text-primary hover:text-blue-700 mr-4">Edit</button>
                        <button 
                          onClick={() => handleDelete(photo.id)}
                          className="text-red-600 hover:text-red-800"
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {filteredPhotos.length === 0 && (
          <div className="text-center py-12">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 mx-auto text-gray-400 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            <h3 className="text-lg font-medium text-gray-900 mb-2">No photos found</h3>
            <p className="text-gray-500">Upload photos to your gallery to get started.</p>
          </div>
        )}

        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-white rounded-lg shadow-md p-6">
            <h3 className="text-lg font-semibold text-gray-800 mb-4">Category Summary</h3>
            <div className="space-y-3">
              {uniqueCategories.map(category => (
                <div key={category} className="flex justify-between">
                  <span>{category}</span>
                  <span className="font-medium">
                    {photos.filter(p => p.category === category).length} photos
                  </span>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-md p-6">
            <h3 className="text-lg font-semibold text-gray-800 mb-4">Gallery Statistics</h3>
            <div className="space-y-3">
              <div className="flex justify-between">
                <span>Total Photos</span>
                <span className="font-medium">{photos.length}</span>
              </div>
              <div className="flex justify-between">
                <span>Categories</span>
                <span className="font-medium">{uniqueCategories.length}</span>
              </div>
              <div className="flex justify-between">
                <span>Added This Month</span>
                <span className="font-medium">
                  {photos.filter(p => {
                    const today = new Date();
                    const photoDate = new Date(p.uploadedDate);
                    return photoDate.getMonth() === today.getMonth() && 
                           photoDate.getFullYear() === today.getFullYear();
                  }).length}
                </span>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-md p-6">
            <h3 className="text-lg font-semibold text-gray-800 mb-4">Quick Actions</h3>
            <div className="space-y-3">
              <button className="w-full bg-primary text-white py-2 px-4 rounded hover:bg-blue-700 transition text-sm">
                Bulk Upload
              </button>
              <button className="w-full bg-green-600 text-white py-2 px-4 rounded hover:bg-green-700 transition text-sm">
                Create Album
              </button>
              <button className="w-full bg-purple-600 text-white py-2 px-4 rounded hover:bg-purple-700 transition text-sm">
                Export Gallery
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GalleryList;